import { Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import { displayVolumeOrPlaceholder } from '../utils/displayVolumeOrPlaceholder'

interface VolumeLabelProps {
  volume?: string | number
}

/**
 * Adapted from cdc-web `Compact/_shared/VolumeLabel.tsx`。
 * 无成交量 / 解析失败（'-'）时自隐藏（OG-9908：不留孤儿 volume 标签）。
 * i18n key 复用 PredictionSection 既有的 `volume: "{volume} vol."`。
 */
export function VolumeLabel({ volume }: Readonly<VolumeLabelProps>) {
  const t = useTranslations('HomePageV2.Prediction')
  const formatted = displayVolumeOrPlaceholder(volume === undefined ? undefined : String(volume))
  if (formatted === '-') return null

  return (
    <Text variant="micro-text" c="var(--content-secondary)">
      {t('volume', { volume: `$${formatted}` })}
    </Text>
  )
}
